import { render, staticRenderFns } from "./SaveBar.vue?vue&type=template&id=15b457aa&scoped=true"
import script from "./SaveBar.vue?vue&type=script&lang=js"
export * from "./SaveBar.vue?vue&type=script&lang=js"
import style0 from "./SaveBar.vue?vue&type=style&index=0&id=15b457aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b457aa",
  null
  
)

export default component.exports